import React from 'react';
import useAuth from '../../../utils/AuthContext';
import CustomerError from '../../../components/CustomerError';
import {UserType} from '../../../hooks/apis/useUser';
import KnowledgeBankEditForm, {IKnowledgeBankEditForm} from '../../../components/KnowledgeBank/EditForm';
import UseKnowledgeBank, {KnowledgeQuestionType, IKnowledgeBank} from '../../../hooks/apis/useKnowledgeBank';
import {Button, Card, Space, Table, Tag} from 'antd';
import Text from 'antd/lib/typography/Text';
import QuickRouter from '../../../utils/QuickRouter';
import CommonApiErrorHandler from '../../../utils/HttpInstance';
import {useMount} from 'react-use';
import useQuickRouter from '../../../utils/QuickRouter';

export default function ManageKnowledgeBankListPage() {
  const auth = useAuth();
  const listState = UseKnowledgeBank.list();
  const quickRouter = useQuickRouter();

  function refresh() {
    listState
      .request()
      .then()
      .catch(CommonApiErrorHandler);
  }

  useMount(() => {
    refresh();
  });

  if (!auth.currentUser || auth.currentUser.type !== UserType.管理员) return <CustomerError title={'无操作权限'} />;
  return (
    <div>
      <Card
        title={'题库列表'}
        extra={
          <Space>
            <Button onClick={refresh}>刷新</Button>
            <Button onClick={quickRouter.manageKnowledgeBankNew}>创建题库</Button>
          </Space>
        }>
        <Table<IKnowledgeBank> loading={listState.loading} rowKey={'id'} dataSource={listState.data} bordered>
          <Table.Column<IKnowledgeBank> title={'ID'} dataIndex={'id'} />
          <Table.Column<IKnowledgeBank> title={'活动名称'} render={(_, item) => <Text strong>{item.name}</Text>} />
          <Table.Column<IKnowledgeBank> title={'类型'} width={150} align={'center'} render={(_, item) => <Tag>{KnowledgeQuestionType[item.type]}</Tag>} />
          <Table.Column<IKnowledgeBank>
            title={'操作'}
            align={'center'}
            width={150}
            render={(_, item) => (
              <Space>
                <a onClick={() => quickRouter.manageKnowledgeBankEdit(item.id)}>编辑</a>
              </Space>
            )}
          />
        </Table>
      </Card>
    </div>
  );
}
